import Typography from "@mui/material/Typography";

const Advance = () => {
	return (
		<div className="flex flex-col">
			<div className="pb-16 flex items-center">
				<Typography className="h2 mx-12 font-medium" color="textSecondary">
					Advance
				</Typography>
			</div>
			<div className="flex flex-col"></div>
		</div>
	);
};

export default Advance;
